import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import appStyles from "../../../../app.module.css";
import ConfigContext from "../../../../context/config-context";
import AppConstants from "../../../classes/constants";
import PriceFormat from "../price-format/price-format";
import ThanksPopUp from "../thanks-pop-up/thanks-pop-up";
import styles from "./quote-result.module.css";

const QuoteResultHeading = ({ commonDetails, defaultQuote }) => {
  if (
    commonDetails?.services.includes(
      AppConstants.QUOTE_SERVICES.CONVEYANCING
    ) &&
    commonDetails?.services.includes(
      AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
    )
  ) {
    return defaultQuote === AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
      ? "Pre-purchase Property Inspection & Conveyancing Quote"
      : "Conveyancing and Pre-purchase Property Inspection Quote";
  } else if (
    commonDetails?.services.includes(
      AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
    )
  ) {
    return "Pre-purchase Property Inspection Quote";
  } else {
    return "Conveyancing Fee Quote";
  }
};

const QuoteResult = (props) => {
  const { common_details, conveyancing_details, inspection_details } =
    props.quoteData;

  const { defaultQuote } = useContext(ConfigContext);

  const [totalGovAndThirdPartyCost, setTotalGovAndThirdPartyCost] = useState(0);
  const [totalServiceAmount, setTotalServiceAmount] = useState(0);
  const [isCollapse, setCollapse] = useState(false);
  const [showThanksPopup, setShowThanksPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const rect = document
        .querySelector(`[id='rezzi_plugin']`)
        ?.getBoundingClientRect();
      const offsetTop = window.pageYOffset + rect.top;
      window.scrollTo(0, offsetTop - 110);
    }, 100);
  }, []);

  useEffect(() => {
    // Total Gov And Third Party Cost Calculation Start
    let govAndThirdPartyCostTotal =
      parseFloat(conveyancing_details?.verification_identity_fee) || 0;

    govAndThirdPartyCostTotal =
      govAndThirdPartyCostTotal +
      (parseFloat(conveyancing_details?.privacy_compliance_fee) || 0);

    if (
      conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
      conveyancing_details?.type === AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH
    ) {
      govAndThirdPartyCostTotal =
        govAndThirdPartyCostTotal +
        (parseFloat(conveyancing_details?.govt_enquiry_fee) || 0);

      if (conveyancing_details?.property_strata_titled) {
        govAndThirdPartyCostTotal =
          govAndThirdPartyCostTotal +
          (parseFloat(
            conveyancing_details?.strata_titles_act_sec_110_certificate
          ) || 0);
      }
    }
    if (
      conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
      conveyancing_details?.type === AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH
    ) {
      if (conveyancing_details?.is_property_deceased_estate) {
        govAndThirdPartyCostTotal =
          govAndThirdPartyCostTotal +
          (parseFloat(conveyancing_details?.apr_or_sa_per_application) || 0) +
          (parseFloat(conveyancing_details?.inperson_settlement_attendance) ||
            0);
      }
    }
    if (
      conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH &&
      conveyancing_details?.buyer_disbursment ===
        conveyancing_details?.seller_disbursment
    ) {
      govAndThirdPartyCostTotal =
        govAndThirdPartyCostTotal +
        (parseFloat(conveyancing_details?.seller_disbursment) || 0);
    } else {
      if (
        conveyancing_details?.type ===
          AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
        conveyancing_details?.type ===
          AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH
      ) {
        govAndThirdPartyCostTotal =
          govAndThirdPartyCostTotal +
          (parseFloat(conveyancing_details?.buyer_disbursment) || 0);
      } else {
        govAndThirdPartyCostTotal =
          govAndThirdPartyCostTotal +
          (parseFloat(conveyancing_details?.seller_disbursment) || 0);
      }
    }
    if (conveyancing_details?.electronic_conveyancing_fee) {
      govAndThirdPartyCostTotal =
        govAndThirdPartyCostTotal +
        (parseFloat(conveyancing_details?.electronic_conveyancing_fee) || 0);
    }
    setTotalGovAndThirdPartyCost(govAndThirdPartyCostTotal);
    // Total Gov And Third Party Cost Calculation End

    // Total Service Amount Calculation Start
    if (
      common_details?.services.includes(
        AppConstants.QUOTE_SERVICES.CONVEYANCING
      )
    ) {
      let serviceAmountTotal = 0;
      if (
        conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER
      ) {
        serviceAmountTotal =
          serviceAmountTotal +
          (parseFloat(conveyancing_details?.calc_buyer_fee) || 0);
      } else if (
        conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER
      ) {
        serviceAmountTotal =
          serviceAmountTotal +
          (parseFloat(conveyancing_details?.calc_seller_fee) || 0);
      } else if (
        conveyancing_details?.type ===
        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH
      ) {
        serviceAmountTotal =
          serviceAmountTotal +
          (parseFloat(conveyancing_details?.calc_buyer_fee) || 0);

        serviceAmountTotal =
          serviceAmountTotal +
          (parseFloat(conveyancing_details?.calc_seller_fee) || 0);
      }

      serviceAmountTotal = serviceAmountTotal + govAndThirdPartyCostTotal;

      setTotalServiceAmount(serviceAmountTotal);
    }
    // Total Service Amount Calculation End
  }, [conveyancing_details]);

  const downloadPDF = (e) => {
    e.preventDefault();
    const fromData = new FormData();
    fromData.append("action", "rsquote_save_quote");
    fromData.append("common_id", common_details.common_id);
    props.downloadPDF(fromData);
  };

  const acceptQuote = (e) => {
    e.preventDefault();
    const fromData = new FormData();
    fromData.append("action", "rsquote_actions");
    fromData.append("common_id", common_details.common_id);
    fromData.append("quote_action", "quote_accepted");
    props.acceptQuote(fromData);
    setShowThanksPopup(true);
  };

  return (
    <div className={styles.quoteResultBlock} id="quoteResultBlock">
      <h2 className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}>
        <QuoteResultHeading
          commonDetails={common_details}
          defaultQuote={defaultQuote}
        />
      </h2>
      <h5 className={`${appStyles.textCenter} ${appStyles.colorDarkGrey}`}>
        Quote number: {common_details?.quote_number || ""}
      </h5>
      <div className={styles.quoteResultBlockSession}>
        <div className={appStyles.colorDarkGrey}>
          Quote Date:{" "}
          {moment(common_details?.quote_date).format("MMM DD, YYYY")}
        </div>
        <div className={`${appStyles.colorDarkGrey} ${appStyles.textRight}`}>
          Quote valid until:{" "}
          {moment(common_details?.quote_valid_till).format("MMM DD, YYYY")}
        </div>
      </div>
      <div className={styles.quoteResultBlockInspectionDetails}>
        <div className={styles.quoteResultBlockInspectionDetailsRow}>
          <p
            className={`${appStyles.colorPrimaryNeutral} ${styles.quoteResultBlockSubheading}`}
          >
            Quote Summary
          </p>
        </div>
        <div
          className={`${styles.quoteResultBlockInspectionDetailsRow} ${
            common_details?.services.includes(
              AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
            ) && styles.hasTwoColumn
          }`}
        >
          <div>
            <label>Prepared for</label>
            <div>
              {common_details?.first_name || ""} {common_details?.surname || ""}
            </div>
          </div>

          {common_details?.services.includes(
            AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
          ) && (
            <div>
              <label>Property Address</label>
              <div>{inspection_details?.property_address || "-"}</div>
            </div>
          )}
        </div>
        <div
          className={`${styles.quoteResultBlockInspectionDetailsRow}  ${styles.fourTwoColumn}`}
        >
          {common_details?.services.includes(
            AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
          ) && (
            <>
              <div>
                <label>Bedrooms</label>
                <div>{inspection_details?.bedroom_count || "-"}</div>
              </div>
              <div>
                <label>Bathrooms</label>
                <div>{inspection_details?.bathroom_count || "-"}</div>
              </div>
            </>
          )}

          {common_details?.services.includes(
            AppConstants.QUOTE_SERVICES.CONVEYANCING
          ) && (
            <>
              <div>
                <label>Buying/Selling</label>
                {conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER && (
                  <div>Buying</div>
                )}
                {conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER && (
                  <div>Selling</div>
                )}
                {conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && <div>Both</div>}
              </div>
              <div>
                {(conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH ||
                  conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER) && (
                  <>
                    <label>
                      Price
                      {conveyancing_details?.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                        <> (Buying)</>
                      )}
                    </label>
                    <div>
                      <PriceFormat
                        value={conveyancing_details?.purchase_price}
                        colorClass={appStyles.colorDark}
                      />
                    </div>
                  </>
                )}
              </div>
              <div>
                {(conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH ||
                  conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER) && (
                  <>
                    <label>
                      Price
                      {conveyancing_details?.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                        <> (Selling)</>
                      )}
                    </label>
                    <div>
                      <PriceFormat
                        value={conveyancing_details?.sale_price}
                        colorClass={appStyles.colorDark}
                      />
                    </div>
                  </>
                )}
              </div>

              {(conveyancing_details?.type ===
                AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
                conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                <>
                  <div>
                    <label>FHO Grant</label>
                    <div>
                      {JSON.parse(
                        conveyancing_details?.first_home_buyer || false
                      )
                        ? "YES"
                        : "NO"}
                    </div>
                  </div>
                  <div>
                    <label>Strata Titled</label>
                    <div>
                      {+conveyancing_details?.property_strata_titled
                        ? "YES"
                        : "NO"}
                    </div>
                  </div>
                  {JSON.parse(conveyancing_details?.vacant_land || false) && (
                    <div>
                      <label>Property Type</label>
                      <div>Vacant Land</div>
                    </div>
                  )}
                </>
              )}

              {(conveyancing_details?.type ===
                AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
                conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                <>
                  <div>
                    <label>Mortgaged</label>
                    <div>
                      {+conveyancing_details?.is_property_mortgaged
                        ? "YES"
                        : "NO"}
                    </div>
                  </div>
                  <div>
                    <label>Deceased Estate</label>
                    <div>
                      {+conveyancing_details?.is_property_deceased_estate
                        ? "YES"
                        : "NO"}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {common_details?.services.includes(
        AppConstants.QUOTE_SERVICES.CONVEYANCING
      ) && (
        <>
          <div className={styles.quoteResultPriceDetails}>
            <p
              className={`${appStyles.colorPrimaryNeutral} ${styles.quoteResultBlockSubheading}`}
            >
              Conveyancing Fee Quote
            </p>

            {(conveyancing_details?.type ===
              AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
              conveyancing_details?.type ===
                AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
              <div className={styles.quoteResultPriceDetailsRow}>
                <h6
                  className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                >
                  Professional Service Fee
                  {conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                    <> (Buying)</>
                  )}
                </h6>
                <div>
                  {conveyancing_details?.calc_buyer_fee ? (
                    <PriceFormat
                      // colorClass={appStyles.colorPrimary}
                      value={conveyancing_details?.calc_buyer_fee}
                      priceWeightClass={styles.priceWeight500}
                    />
                  ) : (
                    <span>NA</span>
                  )}
                </div>
              </div>
            )}

            {(conveyancing_details?.type ===
              AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
              conveyancing_details?.type ===
                AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
              <div className={styles.quoteResultPriceDetailsRow}>
                <h6
                  className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                >
                  Professional Service Fee
                  {conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                    <> (Selling)</>
                  )}
                </h6>
                {conveyancing_details?.calc_seller_fee ? (
                  <PriceFormat
                    // colorClass={appStyles.colorPrimary}
                    value={conveyancing_details?.calc_seller_fee}
                    priceWeightClass={styles.priceWeight500}
                  />
                ) : (
                  <span>NA</span>
                )}
              </div>
            )}

            <div
              className={`${styles.collapse} ${
                isCollapse ? "" : styles.collapseOut
              }`}
            >
              {/* <div className={styles.collapseHeader}>
								<div
									className={
										styles.quoteResultPriceDetailsRow
									}
								>
									<h6>
										Government, Statutory & Other Charges
									</h6>
									{isCollapse && totalGovAndThirdPartyCost ? (
										<PriceFormat
											value={
												totalGovAndThirdPartyCost || 0
											}
											priceWeightClass={
												styles.priceWeight500
											}
										/>
									) : null}
								</div>
							</div> */}
              <div className={styles.collapseBody}>
                {/* BOTH and values are equal then show one field */}
                {conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH &&
                conveyancing_details?.buyer_disbursment ===
                  conveyancing_details?.seller_disbursment ? (
                  <div className={styles.quoteResultPriceDetailsRow}>
                    <p
                      className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                    >
                      Landgate title searches (est, 3 searches, $38.50/search)
                    </p>
                    {conveyancing_details?.buyer_disbursment ? (
                      <PriceFormat
                        value={conveyancing_details?.buyer_disbursment}
                      />
                    ) : (
                      <span>NA</span>
                    )}
                  </div>
                ) : (
                  <>
                    {/* not BOTH and values are equal/not equal then show one field */}
                    {(conveyancing_details?.type ===
                      AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
                      conveyancing_details?.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                      <div className={styles.quoteResultPriceDetailsRow}>
                        <p
                          className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                        >
                          Landgate title searches (est, 3 searches,
                          $38.50/search)
                          {conveyancing_details?.type ===
                            AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                            <> (Buying)</>
                          )}
                        </p>
                        {conveyancing_details?.buyer_disbursment ? (
                          <PriceFormat
                            value={conveyancing_details?.buyer_disbursment}
                          />
                        ) : (
                          <span>NA</span>
                        )}
                      </div>
                    )}

                    {(conveyancing_details?.type ===
                      AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
                      conveyancing_details?.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                      <div className={styles.quoteResultPriceDetailsRow}>
                        <p
                          className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                        >
                          Landgate title searches (est, 3 searches,
                          $38.50/search)
                          {conveyancing_details?.type ===
                            AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH && (
                            <> (Selling)</>
                          )}
                        </p>
                        {conveyancing_details?.seller_disbursment ? (
                          <PriceFormat
                            value={conveyancing_details?.seller_disbursment}
                          />
                        ) : (
                          <span>NA</span>
                        )}
                      </div>
                    )}
                  </>
                )}

                {(conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
                  conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                  <>
                    {conveyancing_details?.property_strata_titled &&
                    conveyancing_details?.strata_titles_act_sec_110_certificate ? (
                      <div className={styles.quoteResultPriceDetailsRow}>
                        <p
                          className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                        >
                          Strata Titles Act Sec 110 certificate (if required)
                        </p>
                        <PriceFormat
                          value={
                            conveyancing_details?.strata_titles_act_sec_110_certificate
                          }
                        />
                      </div>
                    ) : null}

                    {conveyancing_details?.govt_enquiry_fee ? (
                      <div className={styles.quoteResultPriceDetailsRow}>
                        <p
                          className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                        >
                          Government enquiry fees (estimated)
                        </p>
                        <PriceFormat
                          value={conveyancing_details?.govt_enquiry_fee}
                        />
                      </div>
                    ) : null}
                  </>
                )}

                {conveyancing_details?.electronic_conveyancing_fee ? (
                  <div className={styles.quoteResultPriceDetailsRow}>
                    <p
                      className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                    >
                      Electronic settlement platform (PEXA) fees
                    </p>
                    <PriceFormat
                      value={
                        conveyancing_details?.electronic_conveyancing_fee || 0
                      }
                    />
                  </div>
                ) : null}

                {conveyancing_details?.privacy_compliance_fee ? (
                  <div className={styles.quoteResultPriceDetailsRow}>
                    <p
                      className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                    >
                      Privacy & compliance fee
                    </p>
                    <PriceFormat
                      value={conveyancing_details?.privacy_compliance_fee || 0}
                    />
                  </div>
                ) : null}

                {conveyancing_details?.verification_identity_fee ? (
                  <div className={styles.quoteResultPriceDetailsRow}>
                    <p
                      className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                    >
                      Verification of identity (VOI) fee (per person)
                    </p>
                    <PriceFormat
                      value={conveyancing_details?.verification_identity_fee}
                    />
                  </div>
                ) : null}

                {(conveyancing_details?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
                  conveyancing_details?.type ===
                    AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && (
                  <>
                    {conveyancing_details?.is_property_deceased_estate ? (
                      <>
                        {conveyancing_details?.apr_or_sa_per_application ? (
                          <div className={styles.quoteResultPriceDetailsRow}>
                            <p
                              className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                            >
                              Application by Personal Representative or
                              Survivorship Application
                            </p>
                            <PriceFormat
                              value={
                                conveyancing_details?.apr_or_sa_per_application
                              }
                            />
                          </div>
                        ) : null}

                        {conveyancing_details?.inperson_settlement_attendance ? (
                          <div className={styles.quoteResultPriceDetailsRow}>
                            <p
                              className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${styles.quoteResultPriceTitle}`}
                            >
                              In-person settlement attendance
                            </p>
                            <PriceFormat
                              value={
                                conveyancing_details?.inperson_settlement_attendance
                              }
                            />
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </>
                )}

                {/* <div
									className={`${styles.quoteResultPriceDetailsRow} ${styles.quoteResultPriceTotal}`}
								>
									<p
										className={`${appStyles.colorDarkGrey} ${appStyles.smallText} ${appStyles.fontBold} ${styles.quoteResultPriceTitle}`}
									>
										Estimated Total Government, Statutory &
										Other Charges
									</p>
									<PriceFormat
										value={totalGovAndThirdPartyCost || 0}
										priceWeightClass={appStyles.fontBold}
									/>
								</div> */}
              </div>
            </div>

            <div
              className={`${styles.quoteResultPriceDetailsRow} ${styles.quoteResultPriceTotal}`}
            >
              <h6
                className={` ${styles.quoteResultBlockSubheading} ${styles.quoteResultPriceTitle}`}
              >
                Total Service Amount
              </h6>
              <PriceFormat
                value={totalServiceAmount || 0}
                colorClass={appStyles.colorDark}
                priceWeightClass={styles.priceWeight500}
              />
            </div>

            {conveyancing_details?.landgate_registration_fees ? (
              <div className={styles.quoteResultPriceDetailsRow}>
                <h6>Landgate transfer registration fee</h6>
                <PriceFormat
                  value={conveyancing_details?.landgate_registration_fees}
                  colorClass={appStyles.colorDark}
                  priceWeightClass={styles.priceWeight500}
                />
              </div>
            ) : null}

            {(conveyancing_details?.type ===
              AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER ||
              conveyancing_details?.type ===
                AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) &&
            conveyancing_details?.is_property_mortgaged &&
            conveyancing_details?.landgate_discharge_of_mortgage ? (
              <div className={styles.quoteResultPriceDetailsRow}>
                <h6>Landgate Discharge of Mortgage Fee</h6>
                <PriceFormat
                  value={conveyancing_details?.landgate_discharge_of_mortgage}
                  colorClass={appStyles.colorDark}
                  priceWeightClass={styles.priceWeight500}
                />
              </div>
            ) : null}

            {conveyancing_details?.type ===
              AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
            conveyancing_details?.type ===
              AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH ? (
              <div className={styles.quoteResultPriceDetailsRow}>
                <h6>Transfer (stamp) duty </h6>
                {conveyancing_details?.transfer_duty ? (
                  <PriceFormat
                    value={conveyancing_details?.transfer_duty}
                    colorClass={appStyles.colorDark}
                    priceWeightClass={styles.priceWeight500}
                  />
                ) : (
                  <span>NA</span>
                )}
              </div>
            ) : null}
          </div>
        </>
      )}

      {common_details?.services.includes(
        AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
      ) && (
        <div className={styles.quoteResultPriceDetails}>
          <div className={styles.quoteResultBlockInspectionDetailsRow}>
            <p
              className={`${appStyles.colorPrimaryNeutral} ${styles.quoteResultBlockSubheading}`}
            >
              Pre-purchase Property Inspection Quote
            </p>
          </div>

          {inspection_details?.inspection_type.includes(
            AppConstants.QUOTE_INSPECTION_TYPES.STRUCTURAL
          ) && inspection_details?.structural_fee ? (
            <div className={styles.quoteResultPriceDetailsRow}>
              <h6>Pre-purchase Structural Inspection Fee </h6>
              <PriceFormat
                value={inspection_details.structural_fee}
                colorClass={appStyles.colorPrimary}
                priceWeightClass={styles.priceWeight500}
              />
            </div>
          ) : null}

          {inspection_details?.inspection_type.includes(
            AppConstants.QUOTE_INSPECTION_TYPES.STRUCTURAL_MAINTENANCE
          ) && inspection_details.structural_maintenance_fee ? (
            <div className={styles.quoteResultPriceDetailsRow}>
              <h6>
                Pre-purchase Structural Inspection Plus Maintenance Inspection
                Fee
              </h6>
              <PriceFormat
                value={inspection_details.structural_maintenance_fee}
                colorClass={appStyles.colorPrimary}
                priceWeightClass={styles.priceWeight500}
              />
            </div>
          ) : null}

          {inspection_details?.inspection_type.includes(
            AppConstants.QUOTE_INSPECTION_TYPES.TIMBER_PEST
          ) && inspection_details?.timber_pest_fee ? (
            <div className={styles.quoteResultPriceDetailsRow}>
              <h6>Timber Pest Inspection Fee </h6>
              <PriceFormat
                value={inspection_details.timber_pest_fee}
                colorClass={appStyles.colorPrimary}
                priceWeightClass={styles.priceWeight500}
              />
            </div>
          ) : null}
        </div>
      )}

      <div className={styles.quoteResultBookingDetails}>
        {props.error && (
          <div className={`${appStyles.colorDanger} ${appStyles.textCenter}`}>
            {props.error}
          </div>
        )}

        {!props.quoteAccepted && (
          <div className={appStyles.textCenter}>
            <button
              disabled={props.isSubmitting}
              className={`${appStyles.hasButtonLoading} ${
                props.isSubmitting && appStyles.rezziButtonLoading
              }`}
              onClick={acceptQuote}
            >
              {props.isSubmitting && (
                <div className={appStyles.rezziButtonLoader}></div>
              )}
              {!props.isSubmitting && "Accept Quote & Get Started"}
            </button>
          </div>
        )}
        <div className={appStyles.textCenter}>
          <a
            href="#"
            onClick={downloadPDF}
            className={`${appStyles.hasLinkLoading} ${
              styles.downloadQuoteLink
            } ${props.isPdfDownloading && appStyles.rezziLinkLoading}`}
          >
            {props.isPdfDownloading && (
              <div className={appStyles.rezziLinkLoader}></div>
            )}
            Download Quote PDF
          </a>
        </div>
      </div>

      {props.quoteAccepted && (
        <>
          <div className={styles.quoteResultBookingDetails}>
            <h2 className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}>
              Thank You
            </h2>
            <div className={appStyles.textCenter}>
              <strong>
                Have a question? Call us now on{" "}
                <a
                  href={`tel:${AppConstants.PHONE_NUMBER}`}
                  className={appStyles.telphoneLink}
                >
                  {AppConstants.FORMATTED_PHONE_NUMBER}
                </a>
              </strong>
            </div>
          </div>

          {showThanksPopup && (
            <ThanksPopUp
              isPdfDownloading={props.isPdfDownloading}
              downloadPDF={downloadPDF}
              onClose={() => {
                setShowThanksPopup(false);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default QuoteResult;
